import React, { useState, useEffect } from 'react';
import { Button, Checkbox, OnVisible } from '@americanexpress/gravity-core';
import GravityFooter from './GravityFooter';
import GravityHeader from './GravityHeader';
/* istanbul ignore file */
const ScamPage = ({
  handleContinue,
  handleCompleteTranscation,
  queryParams,
  setScamScreen,
  gravityAuthnUrl,
}) => {
  const [checkbox, setCheckbox] = useState(false);
  const [cancelPurchase, setCancelPurchase] = useState(false);
  const [scamTimer, setScamTimer] = useState('');

  useEffect(() => {
    setScamScreen('scam_prompt');
    const timerId = setTimeout(() => {
      handleCompleteTranscation('scam_prompt');
    }, (queryParams.timeouts || {}).scam_prompt || 600000);
    setScamTimer(timerId);
  }, []);

  useEffect(() => {
    if (cancelPurchase) {
      setScamScreen('scam_confirm');
      clearTimeout(scamTimer);
      setScamTimer('');
      const timerId = setTimeout(() => {
        handleCompleteTranscation('scam_confirm');
      }, (queryParams.timeouts || {}).scam_confirm || 20000);
      setScamTimer(timerId);
    }
  }, [cancelPurchase]);

  if (!queryParams.acsTransId) return null;

  const handleContinueBtn = () => {
    clearTimeout(scamTimer);
    setScamTimer('');
    handleContinue();
  };

  const currentScreenId = !cancelPurchase ? 'scam_prompt' : 'scam_confirm';

  return (
    <OnVisible
      identifier="axp-gravity-root"
      acsTransId={queryParams.acsTransId}
      screenId={currentScreenId}
      csEvent={true}
      token={queryParams.token}
      processPayAuthApi={gravityAuthnUrl}
    >
      <GravityHeader
        amount={queryParams.amount}
        cardEndingDigits={queryParams.cardEndingDigits}
        currencyCode={queryParams.currencyCode}
        locale={queryParams.locale}
      />
      {!cancelPurchase
        ? (
          <div id="safekeyStaticMessage" className="safekey-module-container bottom-zero">
            <div id="safekeyBodyWrap" className="safekey-body-wrap no-footer-wrap">
              <div className="safekey-body flex flex-column flex-justify-center flex-align-center text-align-center margin-1-b">
                <i
                  role="img"
                  aria-label="Warning"
                  className="icon icon-lg dls-icon-warning dls-bright-blue safekey-margin-icon safekey-margin-fluid-icon"
                >
                  <p id="warningLabel" title="Warning" aria-hidden={true} />
                </i>
                <div className="safekey-body-title safekey-margin-fluid width-full">
                  Potential Scam
                </div>
                <p className="safekey-md margin-2-b width-full">
                  If someone is pressuring you to make this purchase,
                  {' '}
                  <b>{'it\'s likely a scam.'}</b>
                  {' '}
                  {'If you are confident it\'s not a scam, you can continue. If you\'re unsure, please cancel this purchase now.'}
                </p>

                <div id="truststorediv" className="margin-2-b margin-1-l flex flex-align-center width-full">
                  <div className="checkbox">
                    <Checkbox
                      id="scamContinueCheckbox"
                      label="I have read the above information and wish to continue."
                      aria=""
                      onChange={() => setCheckbox(!checkbox)}
                      value="1"
                      checked={checkbox}
                      index="0"
                      labelStyles="flex safekey-label text-align-left safekey-md"
                      identifier="axp-gravity-root"
                      element="scamContinueCheckbox"
                      detail={`checked: ${!checkbox}`}
                      acsTransId={queryParams.acsTransId}
                      screenId={currentScreenId}
                    />
                  </div>
                </div>
                <div className="width-full">
                  <Button
                    type="button"
                    id="scamContinueBtn"
                    className="btn btn-sm margin-1-b safekey-btn"
                    aria-label="Click continue to proceed with transaction"
                    onClick={() => handleContinueBtn()}
                    disabled={!checkbox}
                    identifier="axp-gravity-root"
                    element="scamContinueBtn"
                    detail="Continue"
                    screenId={currentScreenId}
                  >
                    Continue with Purchase
                  </Button>
                </div>
                <div className="width-full">
                  <Button
                    type="button"
                    id="scamCancelBtn"
                    className="btn btn-sm margin-1-b btn-secondary safekey-btn"
                    aria-label="Click Cancel Purchase to abort the transaction"
                    onClick={() => setCancelPurchase(true)}
                    identifier="axp-gravity-root"
                    element="scamCancelBtn"
                    detail="Cancel Purchase"
                    screenId={currentScreenId}
                  >
                    Cancel Purchase
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <OnVisible
            identifier="axp-gravity-root"
            acsTransId={queryParams.acsTransId}
            screenId={currentScreenId}
            csEvent={true}
            token={queryParams.token}
            processPayAuthApi={gravityAuthnUrl}
          >
            <div id="safekeyStaticMessage" className="safekey-module-container bottom-zero">
              <div id="safekeyBodyWrap" className="safekey-body-wrap no-footer-wrap">
                <div className="safekey-body flex flex-column flex-justify-center flex-align-center text-align-center margin-1-b" aria-labelledby="warningLabel">
                  <div className="safekey-body-title safekey-margin-fluid width-full">
                    This purchase is being cancelled.
                  </div>
                  <p className="safekey-md margin-2-b width-full">
                    {`Please call the number on the back of your Card if 
                      you shared any personal information or Card details. `}
                    <a
                      className="dls-gray-06 text-underline"
                      href="https://www.americanexpress.com/us/security-center/phishing-scam-awareness/#:~:text=If%20you're%20suspicious%2C%20hang,account%20is%20suspended%20or%20closed"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Learn more about how American Express better protects you.
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </OnVisible>
        )}
      <GravityFooter />
    </OnVisible>
  );
};

export default ScamPage;
